var a="#19343F";export{a as default};
